import type { TaskCategory } from "./types";

export const TASK_CATEGORY_OPTIONS: { value: TaskCategory; label: string }[] = [
	{ value: "AGRO", label: "Agro" },
	{ value: "VEGETATION", label: "Ko'kalamzorlashtirish" },
	{ value: "OTHER", label: "Boshqa" },
];

export const TASK_CATEGORY_LABELS: Record<TaskCategory, string> = {
	AGRO: "Agro",
	VEGETATION: "Ko'kalamzorlashtirish",
	OTHER: "Boshqa",
};

export const TASK_CATEGORY_COLORS: Record<TaskCategory, string> = {
	AGRO: "gold",
	VEGETATION: "green",
	OTHER: "default",
};
